<template>
  <main class="cases">
    <section class="sub-hero">
      <div class="hero-wrap">
        <div class="sub-hero-copy">
          <p class="tag" data-i18n="cases-hero-eyebrow" v-html="$rt('cases-hero-eyebrow')"></p>
          <h1 class="hero-title" data-i18n="cases-hero-title" v-html="$rt('cases-hero-title')"></h1>
          <p class="hero-desc" data-i18n="cases-hero-desc" v-html="$rt('cases-hero-desc')"></p>
        </div>

        <ul class="hero-facts surface-glass" data-stat-reveal="">
          <li class="metric-card">
            <span class="hero-fact-icon icon-lg" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M13 3H4C3.44772 3 3 3.44772 3 4V21H14V4C14 3.44772 13.5523 3 13 3Z" fill="color-mix(in srgb, var(--color-brand) 25%, var(--color-surface))"></path>
                <path d="M20 9H14V21H21V10C21 9.44772 20.5523 9 20 9Z" fill="var(--color-brand)"></path>
                <path d="M6.5 6H9.5V8H6.5V6ZM6.5 10H9.5V12H6.5V10ZM6.5 14H9.5V16H6.5V14Z" fill="var(--color-brand)"></path>
                <path d="M16 12H19V14H16V12ZM16 16H19V18H16V16Z" fill="var(--color-surface)"></path>
              </svg>
            </span>
            <div>
              <div class="metric-card__value"><span class="num" data-target="102">0</span><span class="unit">개</span></div>
              <p class="metric-card__label text-label" data-i18n="cases-hero-fact-label-01" v-html="$rt('cases-hero-fact-label-01')"></p>
            </div>
          </li>
          <li class="metric-card">
            <span class="hero-fact-icon icon-lg" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M6 9C7.06087 9 8.07827 9.42142 8.82841 10.1716C9.57856 10.9217 10 11.9391 10 13V18C10 18.2652 9.89464 18.5196 9.70711 18.7071C9.51957 18.8946 9.26522 19 9 19H3C2.73478 19 2.48043 18.8946 2.29289 18.7071C2.10536 18.5196 2 18.2652 2 18V13C2 11.9391 2.42142 10.9217 3.17157 10.1716C3.92172 9.42142 4.93913 9 6 9Z" fill="color-mix(in srgb, var(--color-brand) 25%, var(--color-surface))"></path>
                <path d="M6 8C7.38071 8 8.5 6.88071 8.5 5.5C8.5 4.11929 7.38071 3 6 3C4.61929 3 3.5 4.11929 3.5 5.5C3.5 6.88071 4.61929 8 6 8Z" fill="color-mix(in srgb, var(--color-brand) 25%, var(--color-surface))"></path>
                <path d="M21 19H15C14.7348 19 14.4804 18.8946 14.2929 18.7071C14.1053 18.5196 14 18.2652 14 18V13C14 11.9391 14.4214 10.9217 15.1716 10.1716C15.9217 9.42142 16.9391 9 18 9C19.0609 9 20.0783 9.42142 20.8284 10.1716C21.5786 10.9217 22 11.9391 22 13V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19Z" fill="color-mix(in srgb, var(--color-brand) 25%, var(--color-surface))"></path>
                <path d="M18 8C19.3807 8 20.5 6.88071 20.5 5.5C20.5 4.11929 19.3807 3 18 3C16.6193 3 15.5 4.11929 15.5 5.5C15.5 6.88071 16.6193 8 18 8Z" fill="color-mix(in srgb, var(--color-brand) 25%, var(--color-surface))"></path>
                <path d="M11.1201 12H12.8701C13.931 12 14.9484 12.4214 15.6985 13.1716C16.4487 13.9217 16.8701 14.9391 16.8701 16V21C16.8701 21.2652 16.7648 21.5196 16.5772 21.7071C16.3897 21.8946 16.1353 22 15.8701 22H8.12012C7.8549 22 7.60055 21.8946 7.41301 21.7071C7.22547 21.5196 7.12012 21.2652 7.12012 21V16C7.12012 14.9391 7.54154 13.9217 8.29169 13.1716C9.04183 12.4214 10.0593 12 11.1201 12Z" fill="var(--color-brand)"></path>
                <path d="M12 11C13.3807 11 14.5 9.88071 14.5 8.5C14.5 7.11929 13.3807 6 12 6C10.6193 6 9.5 7.11929 9.5 8.5C9.5 9.88071 10.6193 11 12 11Z" fill="var(--color-brand)"></path>
              </svg>
            </span>
            <div>
              <div class="metric-card__value"><span class="num" data-target="75000">0</span><span class="unit">+</span></div>
              <p class="metric-card__label text-label" data-i18n="cases-hero-fact-label-02" v-html="$rt('cases-hero-fact-label-02')"></p>
            </div>
          </li>
          <li class="metric-card">
            <span class="hero-fact-icon icon-lg" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M18.8824 3H5.11765C3.9481 3 3 3.89543 3 5V19C3 20.1046 3.9481 21 5.11765 21H18.8824C20.0519 21 21 20.1046 21 19V5C21 3.89543 20.0519 3 18.8824 3Z" fill="color-mix(in srgb, var(--color-brand) 25%, var(--color-surface))"></path>
                <path d="M18.5 13H16.5V9.5H13V7.5H18.5V13Z" fill="var(--color-brand)"></path>
                <path d="M16.3 8.21973L11 13.5097L8 10.5097L3 15.5V18.49L8 13.4997L11 16.4997L17.71 9.79973L16.3 8.21973Z" fill="var(--color-brand)"></path>
              </svg>
            </span>
            <div>
              <div class="metric-card__value"><span class="num" data-target="96">0</span><span class="unit">%</span></div>
              <p class="metric-card__label text-label" data-i18n="cases-hero-fact-label-03" v-html="$rt('cases-hero-fact-label-03')"></p>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <section class="catalog fade-up">
      <div class="section-wrap col">
        <div class="section-title text-left">
          <h2 data-i18n="cases-catalog-title" v-html="$rt('cases-catalog-title')"></h2>
          <p class="desc" data-i18n="cases-catalog-desc" v-html="$rt('cases-catalog-desc')"></p>
        </div>

        <div class="section-content">
          <div class="case-filter" data-case-filter="">
            <nav class="part-nav part-nav--compact part-nav--animated" aria-label="사례 분류">
              <span class="part-nav-indicator" aria-hidden="true"></span>
              <button type="button" class="part-nav-item is-active" data-case-tab="all" aria-pressed="true" data-i18n="cases-catalog-filter-01" v-html="$rt('cases-catalog-filter-01')"></button>
              <button type="button" class="part-nav-item" data-case-tab="tool" aria-pressed="false" data-i18n="cases-catalog-filter-02" v-html="$rt('cases-catalog-filter-02')"></button>
              <button type="button" class="part-nav-item" data-case-tab="people" aria-pressed="false" data-i18n="cases-catalog-filter-03" v-html="$rt('cases-catalog-filter-03')"></button>
            </nav>

            <p class="case-count" data-case-count="" aria-live="polite">12개 사례</p>
          </div>

          <ul class="outcome-list" data-case-list="">
            <li data-case-axis="tool">
              <div class="outcome-logo">
                <img src="/images/clients/dark/logo-translink.svg" alt="트랜스링크인베스트먼트 로고" loading="lazy">
              </div>
              <div class="outcome-body">
                <p class="outcome-tags">
                  <span class="tag" data-i18n="cases-catalog-badge-tool" v-html="$rt('cases-catalog-badge-tool')"></span>
                  <span class="tag tag-industry" data-i18n="cases-catalog-industry-01" v-html="$rt('cases-catalog-industry-01')"></span>
                </p>
                <p class="outcome-shift">
                  <span class="outcome-before">3~5일</span>
                  <span class="outcome-arrow" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
                  <span class="outcome-after">1시간</span>
                </p>
                <p class="outcome-detail" data-i18n="cases-catalog-detail-01" v-html="$rt('cases-catalog-detail-01')"></p>
                <p class="outcome-client">트랜스링크인베스트먼트 <span class="outcome-person">박희덕 대표</span></p>
              </div>
            </li>
            <li data-case-axis="tool">
              <div class="outcome-logo outcome-logo--invert">
                <img src="/images/clients/case-study/체인로지스.png" alt="체인로지스 로고" loading="lazy">
              </div>
              <div class="outcome-body">
                <p class="outcome-tags">
                  <span class="tag" data-i18n="cases-catalog-badge-tool" v-html="$rt('cases-catalog-badge-tool')"></span>
                  <span class="tag tag-industry" data-i18n="cases-catalog-industry-02" v-html="$rt('cases-catalog-industry-02')"></span>
                </p>
                <p class="outcome-shift">
                  <span class="outcome-before">2~4시간</span>
                  <span class="outcome-arrow" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
                  <span class="outcome-after">3분</span>
                </p>
                <p class="outcome-detail" data-i18n="cases-catalog-detail-02" v-html="$rt('cases-catalog-detail-02')"></p>
                <p class="outcome-client">체인로지스 <span class="outcome-person">김동현 대표</span></p>
              </div>
            </li>
            <li data-case-axis="tool">
              <div class="outcome-logo">
                <img src="/images/clients/case-study/동탄퍼스트안과.png" alt="동탄퍼스트안과 로고" loading="lazy">
              </div>
              <div class="outcome-body">
                <p class="outcome-tags">
                  <span class="tag" data-i18n="cases-catalog-badge-tool" v-html="$rt('cases-catalog-badge-tool')"></span>
                  <span class="tag tag-industry" data-i18n="cases-catalog-industry-03" v-html="$rt('cases-catalog-industry-03')"></span>
                </p>
                <p class="outcome-headline" data-i18n="cases-catalog-headline-03" v-html="$rt('cases-catalog-headline-03')"></p>
                <p class="outcome-detail" data-i18n="cases-catalog-detail-03" v-html="$rt('cases-catalog-detail-03')"></p>
                <p class="outcome-client">동탄퍼스트안과 <span class="outcome-industry" data-i18n="cases-catalog-industry-tag-03" v-html="$rt('cases-catalog-industry-tag-03')"></span></p>
              </div>
            </li>
            <li data-case-axis="tool">
              <div class="outcome-logo">
                <img src="/images/clients/case-study/세무법인엑스퍼트.png" alt="세무법인 엑스퍼트 로고" loading="lazy">
              </div>
              <div class="outcome-body">
                <p class="outcome-tags">
                  <span class="tag" data-i18n="cases-catalog-badge-tool" v-html="$rt('cases-catalog-badge-tool')"></span>
                  <span class="tag tag-industry" data-i18n="cases-catalog-industry-04" v-html="$rt('cases-catalog-industry-04')"></span>
                </p>
                <p class="outcome-shift">
                  <span class="outcome-before">2~3시간</span>
                  <span class="outcome-arrow" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
                  <span class="outcome-after">10분</span>
                </p>
                <p class="outcome-detail" data-i18n="cases-catalog-detail-04" v-html="$rt('cases-catalog-detail-04')"></p>
                <p class="outcome-client">세무법인 엑스퍼트 <span class="outcome-industry" data-i18n="cases-catalog-industry-tag-04" v-html="$rt('cases-catalog-industry-tag-04')"></span></p>
              </div>
            </li>
            <li data-case-axis="tool">
              <div class="outcome-logo outcome-logo--tall">
                <img src="/images/clients/case-study/우하컴퍼니.png" alt="우하컴퍼니 로고" loading="lazy">
              </div>
              <div class="outcome-body">
                <p class="outcome-tags">
                  <span class="tag" data-i18n="cases-catalog-badge-tool" v-html="$rt('cases-catalog-badge-tool')"></span>
                  <span class="tag tag-industry" data-i18n="cases-catalog-industry-05" v-html="$rt('cases-catalog-industry-05')"></span>
                </p>
                <p class="outcome-shift">
                  <span class="outcome-before">2~3시간</span>
                  <span class="outcome-arrow" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
                  <span class="outcome-after">30초</span>
                </p>
                <p class="outcome-detail" data-i18n="cases-catalog-detail-05" v-html="$rt('cases-catalog-detail-05')"></p>
                <p class="outcome-client">우하컴퍼니 <span class="outcome-industry" data-i18n="cases-catalog-industry-tag-05" v-html="$rt('cases-catalog-industry-tag-05')"></span></p>
              </div>
            </li>
            <li data-case-axis="tool">
              <div class="outcome-logo outcome-logo--tall">
                <img src="/images/clients/case-study/부자테이프.png" alt="부자테이프 로고" loading="lazy">
              </div>
              <div class="outcome-body">
                <p class="outcome-tags">
                  <span class="tag" data-i18n="cases-catalog-badge-tool" v-html="$rt('cases-catalog-badge-tool')"></span>
                  <span class="tag tag-industry" data-i18n="cases-catalog-industry-06" v-html="$rt('cases-catalog-industry-06')"></span>
                </p>
                <p class="outcome-shift">
                  <span class="outcome-before">2~4시간</span>
                  <span class="outcome-arrow" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
                  <span class="outcome-after">5분</span>
                </p>
                <p class="outcome-detail" data-i18n="cases-catalog-detail-06" v-html="$rt('cases-catalog-detail-06')"></p>
                <p class="outcome-client">부자테이프 <span class="outcome-industry" data-i18n="cases-catalog-industry-tag-06" v-html="$rt('cases-catalog-industry-tag-06')"></span></p>
              </div>
            </li>
            <li data-case-axis="people">
              <div class="outcome-logo">
                <img src="/images/clients/case-study/현대엔지비.svg" alt="현대엔지비 로고" loading="lazy">
              </div>
              <div class="outcome-body">
                <p class="outcome-tags">
                  <span class="tag" data-i18n="cases-catalog-badge-people" v-html="$rt('cases-catalog-badge-people')"></span>
                  <span class="tag tag-industry" data-i18n="cases-catalog-industry-07" v-html="$rt('cases-catalog-industry-07')"></span>
                </p>
                <p class="outcome-headline" data-i18n="cases-catalog-headline-07" v-html="$rt('cases-catalog-headline-07')"></p>
                <p class="outcome-detail" data-i18n="cases-catalog-detail-07" v-html="$rt('cases-catalog-detail-07')"></p>
                <p class="outcome-client">현대엔지비 <span class="outcome-industry" data-i18n="cases-catalog-industry-tag-07" v-html="$rt('cases-catalog-industry-tag-07')"></span></p>
              </div>
            </li>
            <li data-case-axis="people">
              <div class="outcome-logo">
                <img src="/images/clients/dark/logo-hyundai-mobis.png" alt="현대모비스 로고" loading="lazy">
              </div>
              <div class="outcome-body">
                <p class="outcome-tags">
                  <span class="tag" data-i18n="cases-catalog-badge-people" v-html="$rt('cases-catalog-badge-people')"></span>
                  <span class="tag tag-industry" data-i18n="cases-catalog-industry-08" v-html="$rt('cases-catalog-industry-08')"></span>
                </p>
                <p class="outcome-headline" data-i18n="cases-catalog-headline-08" v-html="$rt('cases-catalog-headline-08')"></p>
                <p class="outcome-detail" data-i18n="cases-catalog-detail-08" v-html="$rt('cases-catalog-detail-08')"></p>
                <p class="outcome-client">현대모비스 <span class="outcome-industry" data-i18n="cases-catalog-industry-tag-08" v-html="$rt('cases-catalog-industry-tag-08')"></span></p>
              </div>
            </li>
            <li data-case-axis="people">
              <div class="outcome-logo">
                <img src="/images/clients/dark/logo-cj.svg" alt="CJ올리브네트웍스 로고" loading="lazy">
              </div>
              <div class="outcome-body">
                <p class="outcome-tags">
                  <span class="tag" data-i18n="cases-catalog-badge-people" v-html="$rt('cases-catalog-badge-people')"></span>
                  <span class="tag tag-industry" data-i18n="cases-catalog-industry-09" v-html="$rt('cases-catalog-industry-09')"></span>
                </p>
                <p class="outcome-headline" data-i18n="cases-catalog-headline-09" v-html="$rt('cases-catalog-headline-09')"></p>
                <p class="outcome-detail" data-i18n="cases-catalog-detail-09" v-html="$rt('cases-catalog-detail-09')"></p>
                <p class="outcome-client">CJ올리브네트웍스 <span class="outcome-industry" data-i18n="cases-catalog-industry-tag-09" v-html="$rt('cases-catalog-industry-tag-09')"></span></p>
              </div>
            </li>
            <li data-case-axis="people">
              <div class="outcome-logo">
                <img src="/images/clients/dark/logo_1_삼성_(h36).svg" alt="삼성전자 로고" loading="lazy">
              </div>
              <div class="outcome-body">
                <p class="outcome-tags">
                  <span class="tag" data-i18n="cases-catalog-badge-people" v-html="$rt('cases-catalog-badge-people')"></span>
                  <span class="tag tag-industry" data-i18n="cases-catalog-industry-10" v-html="$rt('cases-catalog-industry-10')"></span>
                </p>
                <p class="outcome-headline" data-i18n="cases-catalog-headline-10" v-html="$rt('cases-catalog-headline-10')"></p>
                <p class="outcome-detail" data-i18n="cases-catalog-detail-10" v-html="$rt('cases-catalog-detail-10')"></p>
                <p class="outcome-client">삼성전자 <span class="outcome-industry" data-i18n="cases-catalog-industry-tag-10" v-html="$rt('cases-catalog-industry-tag-10')"></span></p>
              </div>
            </li>
            <li data-case-axis="people">
              <div class="outcome-logo">
                <img src="/images/clients/dark/logo-skt.png" alt="SK텔레콤 로고" loading="lazy">
              </div>
              <div class="outcome-body">
                <p class="outcome-tags">
                  <span class="tag" data-i18n="cases-catalog-badge-people" v-html="$rt('cases-catalog-badge-people')"></span>
                  <span class="tag tag-industry" data-i18n="cases-catalog-industry-11" v-html="$rt('cases-catalog-industry-11')"></span>
                </p>
                <p class="outcome-headline" data-i18n="cases-catalog-headline-11" v-html="$rt('cases-catalog-headline-11')"></p>
                <p class="outcome-detail" data-i18n="cases-catalog-detail-11" v-html="$rt('cases-catalog-detail-11')"></p>
                <p class="outcome-client">SK텔레콤 <span class="outcome-industry" data-i18n="cases-catalog-industry-tag-11" v-html="$rt('cases-catalog-industry-tag-11')"></span></p>
              </div>
            </li>
            <li data-case-axis="people">
              <div class="outcome-logo">
                <img src="/images/clients/case-study/아모레퍼시픽.png" alt="아모레퍼시픽 로고" loading="lazy">
              </div>
              <div class="outcome-body">
                <p class="outcome-tags">
                  <span class="tag" data-i18n="cases-catalog-badge-people" v-html="$rt('cases-catalog-badge-people')"></span>
                  <span class="tag tag-industry" data-i18n="cases-catalog-industry-12" v-html="$rt('cases-catalog-industry-12')"></span>
                </p>
                <p class="outcome-headline" data-i18n="cases-catalog-headline-12" v-html="$rt('cases-catalog-headline-12')"></p>
                <p class="outcome-detail" data-i18n="cases-catalog-detail-12" v-html="$rt('cases-catalog-detail-12')"></p>
                <p class="outcome-client">아모레퍼시픽 <span class="outcome-industry" data-i18n="cases-catalog-industry-tag-12" v-html="$rt('cases-catalog-industry-tag-12')"></span></p>
              </div>
            </li>
          </ul>

        </div>
      </div>
    </section>

    <section class="process fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <p class="mini-title" data-i18n="cases-process-eyebrow" v-html="$rt('cases-process-eyebrow')"></p>
          <h2 data-i18n="cases-process-title" v-html="$rt('cases-process-title')"></h2>
          <p class="desc" data-i18n="cases-process-desc" v-html="$rt('cases-process-desc')"></p>
        </div>

        <div class="section-content">
          <ol class="cycle">
            <li class="blue">
              <span class="cycle-no">1</span>
              <h3 data-i18n="cases-process-step-title-01" v-html="$rt('cases-process-step-title-01')"></h3>
              <p class="description" data-i18n="cases-process-step-desc-01" v-html="$rt('cases-process-step-desc-01')"></p>
              <span class="cycle-arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
            </li>
            <li class="blue">
              <span class="cycle-no">2</span>
              <h3 data-i18n="cases-process-step-title-02" v-html="$rt('cases-process-step-title-02')"></h3>
              <p class="description" data-i18n="cases-process-step-desc-02" v-html="$rt('cases-process-step-desc-02')"></p>
              <span class="cycle-arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
            </li>
            <li class="blue">
              <span class="cycle-no">3</span>
              <h3 data-i18n="cases-process-step-title-03" v-html="$rt('cases-process-step-title-03')"></h3>
              <p class="description" data-i18n="cases-process-step-desc-03" v-html="$rt('cases-process-step-desc-03')"></p>
            </li>
          </ol>
        </div>
      </div>
    </section>

    <section class="cta-final fade-up">
      <div class="section-wrap col cta-final-inner">
        <h2 class="cta-final-title" data-i18n="cases-cta-final-title" v-html="$rt('cases-cta-final-title')"></h2>
        <p class="cta-final-desc" data-i18n="cases-cta-final-desc" v-html="$rt('cases-cta-final-desc')"></p>
        <div class="cta-final-actions">
          <a href="https://codepresso.io/home/contact" class="btn btn-lg">
            <span data-i18n="cases-cta-final-cta" v-html="$rt('cases-cta-final-cta')"></span>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </a>
        </div>
      </div>
    </section>
  </main>

  <ClientInteractions :scripts='["js/fade-up.js","js/header-scroll.js","js/nav-menu.js","js/stat-reveal.js","js/case-filter.js"]' />
</template>

<script setup lang="ts">
import ClientInteractions from '../components/ClientInteractions.vue'
import { useRenewalText } from '../composables/useRenewalText'
import ko from '../data/i18n-dist/Cases/ko.json'
import en from '../data/i18n-dist/Cases/en.json'
import ja from '../data/i18n-dist/Cases/ja.json'
import vi from '../data/i18n-dist/Cases/vi.json'
import es from '../data/i18n-dist/Cases/es.json'

// 문자열은 data/i18n-dist 에서 온다 — 마크업은 키만 들고 있다.
const $rt = useRenewalText({ ko, en, ja, vi, es })
</script>
